import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { section: 'Principale' },
  { path: '/',           icon: '📊', label: 'Dashboard',    ruoli:['admin','segreteria'] },
  { path: '/interventi', icon: '🔧', label: 'Interventi' },
  { path: '/miei-ddt',   icon: '📦', label: 'Miei DDT',    ruoli:['tecnico'] },
  { path: '/clienti',    icon: '👥', label: 'Clienti',      ruoli:['admin','segreteria'] },
  { path: '/mappa-clienti', icon:'🗺️', label: 'Mappa clienti',      ruoli:['admin','segreteria'] },
  { section: 'Fatturazione' },
  { path: '/contratti',  icon: '📄', label: 'Contratti',    ruoli:['admin','segreteria'] },
  { path: '/preventivi', icon: '📋', label: 'Preventivi',   ruoli:['admin','segreteria'] },
  { path: '/fatture',    icon: '💶', label: 'Fatture',  ruoli:['admin','segreteria'] },
  { path: '/ddt',        icon: '📦', label: 'DDT',          ruoli:['admin','segreteria'] },
  { section: 'Magazzino' },
  { path: '/magazzino',  icon: '🧯', label: 'Magazzino',ruoli:['admin','segreteria'] },
  { section: 'Strumenti' },
  { path: '/converti-preventivi', icon:'🔄', label: 'Preventivi → DDT', ruoli:['admin','segreteria'] },
  { path: '/promemoria',      icon:'🔔', label: 'Promemoria',       ruoli:['admin','segreteria'] },
  { path: '/impostazioni',    icon:'⚙️', label: 'Impostazioni',     ruoli:['admin'] },
  { path: '/log',        icon:'📋', label: 'Registro attività',   ruoli:['admin'] },
  { path: '/email',           icon:'📧', label: 'Email',               ruoli:['admin','segreteria'] },
  { path: '/flotta',          icon:'🚐', label: 'Flotta veicoli',        ruoli:['admin','segreteria'] },
  { path: '/quindicizza',     icon:'📄', label: 'Quindicizza',           ruoli:['admin','segreteria'] },
  { path: '/collega-clienti', icon:'🔗', label: 'Collega clienti FIC', ruoli:['admin','segreteria'] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const ruolo = user?.ruolo || 'tecnico';
  const [open, setOpen] = React.useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const tenantSub = localStorage.getItem('quindi_tenant') || '';

  return (
    <>
      {/* Hamburger button mobile */}
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'none',
          position: 'fixed', top: 12, left: 12, zIndex: 200,
          background: '#b30000', color: '#fff', border: 'none',
          borderRadius: 8, width: 44, height: 44, fontSize: 20,
          cursor: 'pointer', alignItems: 'center', justifyContent: 'center',
        }}
        className="hamburger-btn no-print"
      >
        {open ? '✕' : '☰'}
      </button>

      {/* Overlay */}
      {open && (
        <div onClick={() => setOpen(false)}
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:99 }} />
      )}

    <aside className="sidebar" style={{ transform: open ? 'translateX(0)' : undefined }}>
      <div className="sidebar-logo">
        <img src="/quindi-logo.png" alt="Quindi"
          style={{ width:'100%', maxWidth:160, display:'block', margin:'0 auto' }} />
      </div>

      {tenantSub === 'sosfire' && (
        <div style={{ padding:'12px 20px', borderBottom:'1px solid rgba(255,255,255,.1)', display:'flex', alignItems:'center', gap:10 }}>
          <img src="/sosfire-logo.jpg" alt="SOS Fire"
            style={{ width:36, height:36, borderRadius:'50%', objectFit:'cover' }} />
          <div>
            <div style={{ fontSize:12, fontWeight:600, color:'#fff' }}>SOS FIRE</div>
            <div style={{ fontSize:10, color:'rgba(255,255,255,.5)' }}>S.R.L.S.</div>
          </div>
        </div>
      )}

      <nav className="sidebar-nav">
        {NAV.map((item, i) => {
          if (item.section) return <div key={i} className="nav-section">{item.section}</div>;
          // Controlla ruolo
          if (item.ruoli && !item.ruoli.includes(ruolo)) return null;
          return (
            <NavLink key={item.path} to={item.path} end={item.path === '/'}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              onClick={() => setOpen(false)}>
              <span className="icon">{item.icon}</span>
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-bottom">
        <div className="user-info">
          <strong>{user?.nome || user?.username}</strong>
          {user?.ruolo}
        </div>
        <button className="nav-item" onClick={handleLogout} style={{ color:'#f87171' }}>
          <span className="icon">🚪</span> Esci
        </button>
      </div>
    </aside>
    </>
  );
}
